__turbopack_context__.v({
  "bannerImage": "HeroPLP-module-scss-module__DdUNua__bannerImage",
  "bannerImageContainer": "HeroPLP-module-scss-module__DdUNua__bannerImageContainer",
  "contentContainer": "HeroPLP-module-scss-module__DdUNua__contentContainer",
  "heading": "HeroPLP-module-scss-module__DdUNua__heading",
  "logoContainer": "HeroPLP-module-scss-module__DdUNua__logoContainer",
  "mediaContainer": "HeroPLP-module-scss-module__DdUNua__mediaContainer",
  "videoContainer": "HeroPLP-module-scss-module__DdUNua__videoContainer",
});
